export function isNotNullOrUndefined<T>(value: T): value is Exclude<T, null | undefined> {
  return value !== null && value !== undefined
}

export function isObject<T extends Record<string, unknown>>(value: T): value is Exclude<T, null | undefined> {
  return typeof value === 'object' && value !== null && value !== undefined
}
